export default "__VITE_ASSET__$CM74qzm__"